<template>
  <section class="value">
      <div class="value__content container">
				<div class="value__info-container">
          <h2 class="value__title --fade-in-right --delay-1" data-vertical-ivp-class="--animate">The Growing Value of Holistic Health</h2>
					<div class="--fade-in-right --delay-1" data-vertical-ivp-class="--animate">
					<p class="value__description">
						Onassis operates in a space worth hundreds of billions of dollars, 
						giving the company strong potential for growth in its holistic health pursuits. 
					</p>
					<p class="value__description">
						According to a <a class="text-link" href="https://www.grandviewresearch.com/press-release/global-alternative-complementary-medicine-therapies-market" target="_blank">2021 report by Grandview Research</a>, the market for complementary and 
						alternative medicine (CAM) — one that can be described under the “holistic health” umbrella — is 
						projected to register a CAGR of 22.03% through 2028 and reach $404.66 billion. Onassis doesn’t 
						explicitly describe themselves as a CAM business, however their holdings do lie securely in that 
						categorization, where public interest is shifting. 
					</p>
					<p class="value__description">
						The core philosophies of alternative medicine and complementary therapies include strong 
						preference for natural products over synthetic ones, an aversion to quick-fix therapies common 
						in western healthcare practices, and a pursuit of overall, preventative health. 
						Research shows that consumers agree, with a survey in the United States finding that <a class="text-link" href="https://www.globenewswire.com/en/news-release/2022/03/24/2409459/28124/en/Global-Nutraceuticals-Market-2021-to-2026-by-Type-Application-Health-Benefits-Form-and-Geography.html#:~:text=The%20Global%20Nutraceuticals%20Market%20is,at%20a%20CAGR%20of%2010.23%25.&text=The%20key%20factor%20driving%20the,the%20U.S.%20on%20which%2089%25" target="_blank">89% of consumers</a> 
						agree fortified food has health benefits beyond its nutritional value. 
					</p>
					</div>
				</div>
				<figure class="value__img-container --fade-in-left --delay-1" data-vertical-ivp-class="--animate">
					<img src="../assets/value/leaf-sample.png" alt="Leaf sample">
				</figure>
				<figure class="value__img-container-mobile --fade-in-left --delay-1" data-vertical-ivp-class="--animate">
					<img src="../assets/value/leaf-sample-horizontal.jpg" alt="Leaf sample">
				</figure>
      </div>
  </section>
</template>

<script>
export default {
  name: 'Value',
  data () {
    return {
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/value.scss";
</style>
